import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import AppConfig from '../../config';
import { t } from '../../lang';
import RequestService from '../../services/RequestService';
import { appSlice } from '../../store/slices';
import Button from '../Button';
import Icon, { Icons } from '../Icon/Icon';
import { AMLSummaryWithSkeleton } from '../Skeletons/ItemsWithSkeleton';
import './AMLHistoryBlock.scss';

const AMLHistoryBlock = () => {
	const { routes } = AppConfig;
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [amlHistoryArray, setAmlHistoryArray] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		let canceled = false;

		const fetchAmlHistory = async () => {
			setLoading(true);

			try {
				const res = await RequestService.AmlHistory({ Count: 3 });

				if (canceled) return;

				if (res.Status === 'Error') {
					console.log('AML API error', res);
					setAmlHistoryArray([]);
					return;
				}

				setAmlHistoryArray(Array.isArray(res?.AddressesAml) ? res.AddressesAml : []);
			} catch (e) {
				if (!canceled) {
					console.error('AML HISTORY ERROR', e);
					setAmlHistoryArray([]);
				}
			} finally {
				if (!canceled) setLoading(false);
			}
		};

		fetchAmlHistory();

		return () => {
			canceled = true;
		};
	}, []);

	const onAmlScanClick = () => {
		navigate({ pathname: routes.amlCheck });
	};

	const onLearNMoreClick = () => {
		dispatch(
			appSlice.actions.addModal({
				isHeaderWithColorBgAndIcon: true,
				title: t('AML Risk'),
				subtitle: t('Learn about AML risk.'),
				headerBackgroundColor: '#0b8d57',
				headerIcon: 'DefaultAML',
				tag: 'LearnAboutAmlRiskModal',
				isOpen: true,
				height: '65%',
			})
		);
	};

	return (
		<div className='AMLHistoryBlock'>
			{!amlHistoryArray.length && (
				<div className='AMLHistoryBlock_noAml'>
					<div className='AMLHistoryBlock_noAml_container'>
						<Icon type={Icons.EMPTY_ASSETS} height={124} width={240} />
						<div className='AMLHistoryBlock_noAml_container_title'>
							{t('No AML checks yet. Run an AML check to review potential risks for this address.')}
						</div>
						<div className='AMLHistoryBlock_noAml_container_text' onClick={onLearNMoreClick}>
							{t('Learn more v2')}
						</div>
					</div>
					<Button iconBefore={'AML_SCAN'} styleType='green-dark' onClick={onAmlScanClick}>
						{t('AML check')}
					</Button>
				</div>
			)}
			{amlHistoryArray.length > 0 && (
				<div className='AMLHistoryBlock_aml'>
					<div className='AMLHistoryBlock_aml_header'>
						<div className='AMLHistoryBlock_aml_header_title'>{t('Recent AML checks')}</div>
						<Link to={routes.amlHistory}>{t('View all v2')}</Link>
					</div>

					<AMLSummaryWithSkeleton loading={loading} blockchainName='Bitcoin' items={amlHistoryArray} passIndex />
				</div>
			)}
		</div>
	);
};

export default AMLHistoryBlock;
